import { useEffect, useState } from "react";

/**
 *  Hook to indicate if the device is a touch device.
 *
 *  @returns [isTouchDevice: boolean]
 */
export function useIsTouchDevice() {
    const [isTouchDevice, setIsTouchDevice] = useState(false);

    useEffect(() => {
        const hasTouch =
            ("ontouchstart" in window || window.matchMedia("(pointer: coarse)").matches) &&
            navigator.maxTouchPoints > 0;

        setIsTouchDevice(hasTouch);
    }, []);

    return isTouchDevice;
}
